// @ts-check
import { css, jsx } from '@emotion/core';
import React from 'react';

import Link from '@/src/shared/components/Link';
import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';
import useStaffProfiles from "./useStaffProfiles";

const style = {
  name: css`
    color: ${colors.secondaryBlue};
    font-weight: bolder;
  `,
  sorterText: css`
    font-weight: bolder;
    margin-bottom: 0px;
  `,
};

const NameSort = () => {
  const { data, loading } = useStaffProfiles('name');

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="personId"
        showHeader={false}
        pagination={false}
        scroll={{ x: 670 }}
        css={css`
          .ant-table-row-cell-break-word {
            white-space: normal !important;
          }
        `}
      />
    </>
  );
};

/** @type {import("./useStaffProfiles").StaffProfileColumn[]} */
const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    render: (text, record) => {
      return (
        <Link
          anchor
          css={style.name}
          data-attr={record.name}
          href={`mailto:${record.emailAddress}`}
        >
          {text}
        </Link>
      );
    },
    width: '250px',
  },
  {
    title: 'Title',
    dataIndex: 'title',
    width: '240px',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    render: (text, record) => {
      return (
        <Link anchor data-attr={record.name} href={`tel:${text}`}>
          {text}
        </Link>
      );
    },
    width: '180px',
  },
];

export default NameSort;
